export default __webpack_public_path__ + "4bb9ad2714acbc6bd60d41379f5c1170.jpg";